import type { TransactionHistoryFilterRequest } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'
import TransactionsTable from './TransactionsTable'
import './RecentTransactions.scss'

interface Props {
  title?: string
  filter?: TransactionHistoryFilterRequest
  showPagination?: boolean
  forceReload?: boolean
}

function RecentTransactions({ title = '', filter = {}, showPagination = false, forceReload = false }: Props) {
  return (
    <div>
      <div className='transactions-section-title'>
        {title || tr('PORTAL.DASHBOARD.TRANSACTIONS', 'Recent transactions')}
      </div>
      <TransactionsTable filter={filter} showPagination={showPagination} forceReload={forceReload} />
    </div>
  )
}

export default RecentTransactions
